import { render, staticRenderFns } from "./PptView.vue?vue&type=template&id=29cf5bf6&scoped=true&"
import script from "./PptView.vue?vue&type=script&lang=js&"
export * from "./PptView.vue?vue&type=script&lang=js&"
import style0 from "./PptView.vue?vue&type=style&index=0&id=29cf5bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf5bf6",
  null
  
)

export default component.exports